import { useState, useEffect } from 'preact/hooks';
import Modal from './shared/Modal.jsx';
import Button from './shared/Button.jsx';

// De gebruikers die 4U uit dit product heeft opgehaald. Niet de debiteuren —
// dit zijn de mensen die inloggen, niet de partij die betaalt.
export default function ProductUsersModal({ isOpen, product, onClose }) {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!isOpen || !product) return;
    let cancelled = false;
    setLoading(true);
    setFailed(false);
    fetch(`/api/product-users?productId=${product.id}`, { credentials: 'same-origin' })
      .then(r => r.ok ? r.json() : Promise.reject(new Error('load_failed')))
      .then(d => { if (!cancelled) setUsers(d.users || []); })
      .catch(() => { if (!cancelled) setFailed(true); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [isOpen, product]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={`Gebruikers in ${product?.name || ''}`}>
      {loading ? (
        <div class="empty-state muted">Laden…</div>
      ) : failed ? (
        <div class="empty-state muted">Gebruikers konden niet worden geladen.</div>
      ) : users.length === 0 ? (
        <div class="empty-state">
          <p>Nog geen gebruikers opgehaald.</p>
          <p class="muted">
            4U haalt ze elke 5 minuten op bij <code>/api/4u/users</code>.
            Werkt dat endpoint al in dit product?
          </p>
        </div>
      ) : (
        <table class="data-table">
          <thead>
            <tr><th>E-mail</th><th>Naam</th><th>Ook in</th></tr>
          </thead>
          <tbody>
            {users.map(u => (
              <tr key={u.id}>
                <td>{u.email || <span class="muted">onbekend</span>}</td>
                <td>{u.name || <span class="muted">—</span>}</td>
                <td class="muted">
                  {u.products.filter(p => p.id !== product.id).map(p => p.name).join(', ') || '—'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      <div class="form-actions">
        <Button type="button" onClick={onClose}>Sluiten</Button>
      </div>
    </Modal>
  );
}
